import Vue from 'vue';
import {helpers} from "../../helpers";

export default {
    store: {
        namespaced: true,
        state: {
            address_type: {},
            address_types: [],
            addresses: [],
            addresses_amount: 0
        },
        actions: {
            //получение типов адреса
            getAddressTypes({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/address_type', {params: data}).then(r => {
                    if (!r || !r.data) return null;
                    Vue.set(state, 'address_types', (r.data || r));
                    return r;
                });
            },

            //получение типа адреса
            getAddressType({ state, rootState }, options) {
                helpers.http.get({context: this, rootState}, '/address_type/byid/' + options.id).then(r => {
                    Vue.set(state, 'address_type', r);
                    return r;
                });
            },

            //добавление типа адреса
            addAddressType({ rootState }, options) {
                return helpers.http.post({context: this, rootState}, '/address_type', options.type);
            },

            //обновление типа адреса
            updateAddressType({ rootState }, options) {
                return helpers.http.put({context: this, rootState}, '/address_type', options.type);
            },

            //удаление типа адреса
            deleteAddressType({ rootState }, options) {
                return helpers.http.delete({context: this, rootState}, '/address_type/byid/' + options.id);
            },

            //добавление адреса
            postAddress({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/addresses', data);
            },

            //добавление адреса
            putAddress({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/addresses', data);
            },

            getAddresses({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/addresses', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    Vue.set(state, 'addresses', r.data);
                    Vue.set(state, 'addresses_amount', r.total);
                    return r.data;
                });
            },
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/address/store.js